import { Component } from '@angular/core';
import * as $ from 'jquery';

import { SharedService } from './services/shared.service';
import { LoginService } from './services/login.service';
import { StorageService } from './services/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'abe-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
 
  showTemplate: boolean = false;
  public shared: SharedService;

  constructor(
    private loginService: LoginService,
    private storage: StorageService,
    private route: Router
  ) {
    this.shared = SharedService.getInstance();
  }

  ngOnInit() {
    this.shared.showTemplate.subscribe( res => {
      this.showTemplate = res;
    })
  }

  ngDoCheck() {
    let localUser = this.storage.getLocalUser();

    if (localUser) {

      if (this.loginService.tokenExpired(localUser.token)) {
        this.shared.showTemplate.emit(false);
        this.route.navigate(['/']);
        localStorage.clear();
      } 
    }    
  }

  

}
